module.exports = __webpack_public_path__ + "img/dark-home.0c6ebaf0.svg";